<!-- 大-统一 -->
<template>
  <div
    class="cardContent"
    :style="{
      backgroundImage: `url(${backgroundImage})`,
    }"
  >
    <div class="cardTop">
      <span class="title">{{ previewData.title || "这是小部件标题" }}</span>
      <span
        class="time"
        v-if="
          (previewData.filterType == 1 || previewData.filterType == 2) &&
          !previewData.isBanGoodsShow
        "
        >距结束 <span class="day">xx</span>天 <span class="day">hh</span>:
        <span class="day">mm</span>: <span class="day">ss</span></span
      >
    </div>
    <div
      :class="{
        cardTop2: true,
        filterCard:
          (previewData.filterType == 1 || previewData.filterType == 2) &&
          !previewData.isBanGoodsShow,
      }"
    >
      <div class="left-section">
        <div class="avatar-section">
          <!-- <i class="el-icon-user-solid avatar-icon"></i> -->
        </div>
        <div class="user-name">王*小</div>
      </div>
      <div class="right-section">
        <div class="progress-line">
          <div class="progress-bar">
            <div class="progress-fill"></div>
          </div>
          <!-- <div class="progress-dot"></div> -->
        </div>
        <div class="amount-display">
          <span class="bought-amount"
            >已买0{{ getStatisticUnit
            }}<template v-if="previewData.itemLimitCount">且0件</template></span
          >
          <span class="target-amount"
            >满{{ getTargetAmount }}{{ getStatisticUnit
            }}<template v-if="previewData.itemLimitCount"
              >且{{ previewData.itemLimitCount }}件</template
            ></span
          >
        </div>
        <div class="condition-text">{{ getConditionText() }}</div>
      </div>
    </div>
    <div
      :class="{
        cardTop3: true,
        filterCard:
          (previewData.filterType == 1 || previewData.filterType == 2) &&
          !previewData.isBanGoodsShow,
      }"
    >
      <!-- UI改布局, 左右切换了 -->
      <div class="right-content">
        <div class="image-section">
          <div class="awardIconBox-top3">
            <img
              :src="previewData.logo || getLogo(previewData.prizeType)"
              style="width: 100%; height: 100%"
            />
            <div class="prize-count">剩余xxx份</div>
          </div>
          <span class="awardIndex-top3"> 1/{{ previewData.imgCount }} </span>
        </div>
      </div>
      <div class="left-content">
        <div class="activity-theme-top3">
          {{ previewData.topic || "活动主题" }}
        </div>
        <div class="activity-description">
          {{ previewData.description || "活动说明" }}
        </div>
        <span class="remain_count">剩余xxx份</span>
        <div
          :class="{
            'activity-join': true,
            Op0: previewData.isShowParticipateNum != 1,
          }"
        >
          <span>132人已参加</span>
        </div>
        <div
          class="signup-button2"
          v-if="
            (previewData.filterType == 1 || previewData.filterType == 2) &&
            !previewData.isBanGoodsShow
          "
        >
          <span :style="{
            background: cusTemplateJSON.btnColor1 ? `linear-gradient( 33deg, ${cusTemplateJSON.btnColor1} 0%, ${cusTemplateJSON.btnColor2} 100%)` : ''
            }"
          >
            立即报名
          </span>
        </div>
      </div>
    </div>
    <div
      class="cardTop4"
      v-if="
        (previewData.filterType != 1 && previewData.filterType != 2) ||
        !(
          (previewData.filterType == 1 || previewData.filterType == 2) &&
          !previewData.isBanGoodsShow
        )
      "
    >
      <div class="countdown-container">
        距活动结束<span class="countdown-number">xx</span>天<span
          class="countdown-number"
          >hh</span
        >:<span class="countdown-number">mm</span>:<span
          class="countdown-number"
          >ss</span
        >
      </div>
      <div class="signup-button-top3">
        <span :style="{
          background: cusTemplateJSON.btnColor1 ? `linear-gradient( 33deg, ${cusTemplateJSON.btnColor1} 0%, ${cusTemplateJSON.btnColor2} 100%)` : ''
          }"
        >
          立即报名
        </span>
      </div>
    </div>
    <div
      class="cardTop5"
      v-if="
        (previewData.filterType == 1 || previewData.filterType == 2) &&
        !previewData.isBanGoodsShow
      "
    >
      <div class="specified-products-container">
        <div class="specified-products-header">
          <span class="specified-products-title">{{
            previewData.filterType == 1 ? "指定商品" : "排除商品"
          }}</span>
          <span class="specified-products-desc"
            >*{{
              previewData.filterType == 1
                ? "只要订单包含指定商品就整单统计"
                : "只要订单包含指定商品就整单排除"
            }}</span
          >
        </div>
        <div class="products-list">
          <div
            class="product-item"
            v-for="(item, index) in previewData.itemList"
            :key="index"
          >
            <div class="product-image">
              <img :src="item.logo" :alt="item.title" />
            </div>
            <div class="product-name">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityCard",
  props: {
    previewData: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    unitName: {
      type: String,
      default: "",
    },
    cusTemplateJSON: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    getStatisticUnit() {
      const statisticType = this.previewData.statisticType;
      switch (statisticType) {
        case 0:
          return "元";
        case 1:
          return "件";
        case 3:
          return "笔";
        case 4: // 自定义计量单位
          return this.unitName;
        default:
          return "元"; // 默认显示元
      }
    },
    getTargetAmount() {
      const statisticType = this.previewData.statisticType;
      switch (statisticType) {
        case 0:
          return this.previewData.orderPaymentLimit; // 满额
        case 1:
          return this.previewData.itemLimitCount; // 满件
        case 3:
          return this.previewData.orderLimitCount; // 满笔
        case 4: // 自定义计量单位
          return this.previewData.measureUnitLimitCount; // 自定义计量单位的消费门槛
        default:
          return this.previewData.orderPaymentLimit; // 默认满额
      }
    },
  },
  mounted() {
    console.log("--- ~ this.previewData3:---", this.previewData);
  },
  methods: {
    getConditionText() {
      // 当activityType为46时，根据statisticType判断
      if (this.previewData.activityType === 46) {
        const statisticType = this.previewData.statisticType;
        const orderCountType = this.previewData.orderCountType;
        const orderPaymentLimit = this.previewData.orderPaymentLimit;
        const itemLimitCount = this.previewData.itemLimitCount;
        const orderLimitCount = this.previewData.orderLimitCount;
        const measureUnitLimitCount = this.previewData.measureUnitLimitCount;

        const prefix = orderCountType == 1 ? "累计" : "单笔";

        switch (statisticType) {
          case 0: // 满额
            return `${prefix}满${orderPaymentLimit}元(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 1: // 满件
            return `${prefix}满${itemLimitCount}件(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 2: // 满额满件
            return `${prefix}满${orderPaymentLimit}元且商品满${itemLimitCount}件(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 3: // 满笔
            return `${prefix}满${orderLimitCount}笔(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
          case 4: // 自定义计量单位
            return `${prefix}满${measureUnitLimitCount}${this.getStatisticUnit}`;
          default:
            return `${prefix}满${orderPaymentLimit}元且商品满${itemLimitCount}件(${
              this.previewData.orderType == 0 ? "订单付款" : "订单完成"
            })`;
        }
      } else {
        // 其他活动类型都是满额满件
        const orderCountType = this.previewData.orderCountType;
        const orderPaymentLimit = this.previewData.orderPaymentLimit; // 订单金额
        const itemLimitCount = this.previewData.itemLimitCount; // 商品件数
        // 首单专享礼
        if (this.previewData.activityType === 17) {
          if (!itemLimitCount) {
            return `单笔满${orderPaymentLimit}元`;
          }
          return `单笔满${orderPaymentLimit}元且商品满${itemLimitCount}件`;
        }
        const prefix = orderCountType == 1 ? "累计" : "单笔";
        if (!itemLimitCount) {
          return `${prefix}满${orderPaymentLimit}元`;
        }
        return `${prefix}满${orderPaymentLimit}元且商品满${itemLimitCount}件`;
      }
    },
    // 获取图片
    getLogo(prizeType) {
      let logo = "";
      if (prizeType == 1) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_coupon.png";
      } else if (prizeType == 2) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_jd.png";
      } else if (prizeType == 4) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_jf.png";
      } else if (prizeType == 5) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_ecard.png";
      } else if (prizeType == 6) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_iqiyi.png";
      } else if (prizeType == 7) {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_plus.png";
      } else {
        logo = "http://cdn-image.yucrm.cn/images/V24/popup_hb.png";
      }
      return logo;
    },
  },
};
</script>

<style lang="scss" scoped>
.cardContent {
  position: absolute;
  top: 170px;
  left: 5px;
  height: 223px;
  width: 98%;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;

  .cardTop {
    display: flex;
    justify-content: space-between;
    padding: 4px 14px 0px 4px;
    font-size: 8px;

    .title {
      color: #fff;
      width: 65px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .time {
      .day {
        color: #c20002;
        padding: 0px 4px;
        background-color: rgba(0, 0, 0, 0.2);
      }
    }
  }
}

.cardTop2 {
  background-color: rgba(255, 255, 255, 0.7);
  padding: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 18px 8px 0 4px;
  border-radius: 6px 6px 0 0;

  .left-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;

    .avatar-section {
      display: flex;
      align-items: center;
      justify-content: center;
      background-image: url("https://cdn-image.yucrm.cn//hd/images/13315956_8cc9b45ed69e40ae8bc0df12526492f9.png");
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background-size: cover;
      .avatar-icon {
        font-size: 20px;
        color: #909399;
      }
    }

    .user-name {
      font-size: 8px;
      color: #333;
      text-align: center;
    }
  }

  .right-section {
    flex: 1;
    margin-left: 12px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    .condition-text {
      color: #999;
      font-size: 8px;
      text-align: start;
      line-height: 1.2;
    }

    .progress-line {
      display: flex;
      align-items: center;
      margin: 1px 0;

      .progress-bar {
        flex: 1;
        height: 1px;
        background-color: #ddd;
        position: relative;

        .progress-fill {
          width: 50%;
          height: 100%;
          background-color: #000;
          border-radius: 1px;
        }
      }

      .progress-dot {
        width: 4px;
        height: 4px;
        background-color: #000;
        border-radius: 50%;
        margin-left: -8px;
        position: relative;
        z-index: 1;
      }
    }

    .amount-display {
      display: flex;
      justify-content: space-between;
      font-size: 8px;

      .bought-amount {
        color: #333;
      }

      .target-amount {
        color: #333;
      }
    }
  }
}

.cardTop3 {
  display: flex;
  justify-content: space-between;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 10px 4px 10px 14px;
  margin: 0 8px 8px 4px;
  border-radius: 0px 0px 6px 6px;
  .left-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;

    .activity-theme-top3 {
      color: #333;
      font-size: 12px;
      font-weight: bold;
      text-align: start;
    }

    .activity-description {
      width: 120px;
      color: #666;
      font-size: 10px;
      text-align: start;
      line-height: 1.2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .activity-join {
      display: flex;
      justify-content: end;
      align-items: center;
      font-size: 7px;
      padding: 0 6px;
      color: #666;
      width: 85px;
      height: 15px;
      background-color: rgba(255, 255, 255, 0.7);
      border-radius: 15px;
      position: relative;
      &.Op0 {
        opacity: 0;
      }
      ::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 4px;
        transform: translateY(-55%);
        width: 30px;
        height: 10px;
        background-image: url("https://cdn-image.yucrm.cn//hd/images/13315956_a4aa1be4208b45bda373781e0667c8a3.png");
        background-size: cover;
      }
    }
  }

  .right-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    margin-right: 10px;

    .image-section {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;

      .awardIconBox-top3 {
        width: 55px;
        height: 55px;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        overflow: hidden;
        // border: 1px solid #fff;
        position: relative;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .awardIndex-top3 {
        font-size: 8px;
        color: #666;
      }
    }

    .signup-button-top3 {
      span {
        background-color: #000;
        color: #fff;
        font-size: 8px;
        text-align: center;
        padding: 6px 12px;
        border-radius: 12px;
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }
}

.cardTop2.filterCard {
  background-color: #f9fafc;
  padding: 8px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 8px 0px 4px;
  border-radius: 6px 6px 0 -0;
}

.cardTop3.filterCard {
  padding: 4px 4px 4px 14px;
  // margin-top: 4px;
  .right-content {
    gap: 0px;
    .image-section {
      .awardIconBox-top3 {
        width: 45px;
        height: 45px;
      }
    }
  }
}

.cardTop4 {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.countdown-container {
  width: 120px;
  height: 20px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: #333;
  margin-top: 5px;
}

.countdown-number {
  color: #ce2d2f;
}

.prize-count {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 6px;
  padding: 2px 4px;
  text-align: center;
  border-radius: 2px;
  position: absolute;
  bottom: 0;
  left: 0;
}

.cardTop5 {
  margin: 4px 8px 2px 4px;

  .specified-products-container {
    background-color: rgba(0, 0, 0, 0.08);
    border-radius: 4px;
    padding: 4px;

    .specified-products-header {
      margin-bottom: 2px;
      line-height: 8px;

      .specified-products-title {
        color: #333;
        font-size: 9px;
        font-weight: bold;
        margin-right: 8px;
      }

      .specified-products-desc {
        color: #333;
        font-size: 8px;
      }
    }

    .products-list {
      display: flex;
      gap: 4px;
      overflow-x: auto;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE and Edge */
      &::-webkit-scrollbar {
        display: none; /* Chrome, Safari and Opera */
      }

      .product-item {
        flex-shrink: 0;
        width: 39px;
        background-color: #fff;
        padding: 2px;
        border-radius: 2px;
        .product-image {
          width: 35px;
          height: 35px;
          border-radius: 2px;
          overflow: hidden;
          margin-bottom: 2px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .product-name {
          font-size: 7px;
          line-height: 1.2;
          text-align: center;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
        }
      }
    }
  }
}
.signup-button-top3 {
  span {
    background-color: #000;
    color: #fff;
    font-size: 9px;
    text-align: center;
    padding: 6px 12px;
    border-radius: 12px;
    cursor: pointer;
    white-space: nowrap;
  }
}
.remain_count {
  width: fit-content;
  display: flex;
  font-size: 7px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 2px 4px;
  border-radius: 2px;
}

.signup-button2 {
  display: flex;
  justify-content: end;
  margin-left: 8px;
  margin-top: -20px;
  align-items: center;

  span {
    background-color: #000;
    color: #fff;
    width: 50px;
    font-size: 8px;
    text-align: center;
    padding: 6px 6px;
    border-radius: 10px;
    cursor: pointer;
  }
}
</style>
